import { useState } from 'react'
import { Box } from '@mui/material'
import '../create-object-page/CreateObjectPage.css'
import { PropertyName } from './PropertyName.tsx'
import type { PropertyValue } from '../services/ObjectsService'
import { PropertyInput } from './PropertyInput.tsx'
import { propertyFormConfig } from './PropertyFormConfig.tsx'
import type { PropertyDefinitionModel } from '@/core/gql/gql-models-override.ts'

const config = propertyFormConfig

export interface PropertyFormProps {
  propDef: PropertyDefinitionModel
  initialValue: PropertyValue
  nameWidthPx: number
  inputMaxWidth?: number
  readonly?: boolean
}

export function PropertyForm(props: PropertyFormProps) {
  const { propDef, initialValue, nameWidthPx, inputMaxWidth, readonly } = props
  const [isHoveredOn, setIsHoveredOn] = useState(false)

  const chipHeight = '40px'
  const iconSize = 25

  const fontSize = propertyFormConfig.fontSize

  const halfMixin = {
    px: 0.5,
    height: 'auto',
  }

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%', height: `${config.propHeight}px` }}>
        <PropertyName propDef={propDef} widthPx={nameWidthPx} />
        <PropertyInput propDef={propDef} initialValue={initialValue} readonly={readonly} maxWidth={inputMaxWidth} />
      </Box>
    </>
  )
}
